import { IReportContext } from 'assets/js/pages/reports/ReportContext';
import { isoDateFromServer } from 'helpers/dates';
import { capitalize } from 'lodash';
import { DateTime } from 'luxon';
import { Report, ReportResource, ReportSchema } from 'types/domain';

const getDatetimeRangeFromUpstream = ([start, end]: [string, string]): [DateTime, DateTime] => [
    isoDateFromServer(start),
    isoDateFromServer(end),
];

const getInitialState = (
    report: Report,
    { columns }: ReportSchema,
): Pick<
    IReportContext,
    'dateRange' | 'dateRangeType' | 'chartColumn' | 'chartType' | 'sortColumn' | 'sortDirection'
> => {
    return {
        dateRange: report.query.date_range?.range.every(r => !!r)
            ? getDatetimeRangeFromUpstream(report.query.date_range.range as [string, string])
            : [DateTime.now().set({ month: 1, day: 1 }), DateTime.now()],
        dateRangeType: report.query.date_range?.type ?? 'YTD',
        chartColumn: columns.find(col => col.name === report.query.graph_settings?.column),
        chartType: report.query.graph_settings?.graph_type ?? undefined,
        sortColumn: columns.find(col => col.name === report.query.display_settings.order_by),
        sortDirection: report.query.display_settings.order_by_direction ?? undefined,
    };
};

const getReportResourceType = (type: ReportResource) => {
    if (type === 'transaction_plans') {
        return 'Recurring plans';
    }
    return capitalize(type);
};

export { getDatetimeRangeFromUpstream, getInitialState, getReportResourceType };
